export const BRIDGE_TYPE_ONSITE = 'onsite'
export const BRIDGE_TYPE_VIRTUAL = 'virtual'

export default {
  ONSITE: BRIDGE_TYPE_ONSITE,
  VIRTUAL: BRIDGE_TYPE_VIRTUAL,
}
